<template>
  <div id="introduce-guideline">
    <section id="Tổng Quan">
      <h4>Tổng Quan</h4>
      <p>
        Màn hình biểu diễn kết quả thống kê toàn bộ content đang có (overview)
        hoặc là các content được cập nhật gần nhất (last overview)<br /><br />
        Kết quả biểu diễn 4 loại metadata chính :
        <b>celeb, common object, emotion, action, scene, age, gender, food.</b>
        Thông tin được hệ thống tính toán và cập nhật tự động mỗi ngày vào lúc
        <b> 11h AM</b>
      </p>
      <img src="../../assets/tutorial/screen-dashboard.png" />
    </section>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { mdiChatAlert } from "@mdi/js";
export default {
  data() {
    return {
      mdiChatAlert: mdiChatAlert,
      currentSectionId: "",
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    let items = document.getElementById("introduce-guideline")?.childNodes;
    if (items) {
      let ids = Array.prototype.reduce.call(
        items,
        function (arr, elem) {
          arr.push(elem.id);
          return arr;
        },
        []
      );
      this.setListTitle([...ids]);
    }
  },
  beforeDestroy() {
    localStorage.removeItem("myAnchorTilte");
    this.setListTitle([]);
  },
  computed: {
    myAnchorTilte: sync("showcase/myAnchorTilte"),
  },
  methods: {
    setListTitle: call("showcase/setListTitle"),
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const sections = document.getElementById(
        "introduce-guideline"
      ).childNodes;
      let currentSectionIndex = 0;
      for (let i = 0; i < sections.length; i++) {
        const sectionTop = sections[i].offsetTop - 125;
        const sectionBottom = sectionTop + sections[i].offsetHeight;
        if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
          currentSectionIndex = i;
          break;
        }
      }
      const currentSectionId = sections[currentSectionIndex].getAttribute("id");

      if (this.myAnchorTilte !== currentSectionId) {
        this.myAnchorTilte = currentSectionId;
        localStorage.setItem("myAnchorTilte", currentSectionId);
      }
    },
  },
};
</script>

<style></style>
